export class OverrideDrug {
    DrugId: number;
    MedicationSource: number;
    DrugTitle: string;
    IsOverride: boolean;
    Comment: string;
    ResultType : number;
}